<template>
  <div class="row align-items-top">
    <div class="col"></div>
    <div v-if="(isInProgress === false)" class="row align-items-center pr-2 mr-2">
      <SideMenuDisplayer>
        <template v-slot:title>

          <div style='font-size: 1.25rem'>
            <span class='icon icon-settings align-middle'>
            </span>
            <span class='mr-auto my-auto align-middle'>
              Display settings
            </span>
          </div>
        
        </template>
        <template v-slot:content>

          <div class="row justify-content-end">
            <fieldset class="border border-600 px-2 pb-1 my-1 text-left rounded">
              <legend class="pl-2 ">Merge Options</legend>
              <div class="col px-1">
                <div class="col-12 justify-content-end">
                  <div class="col-12">
                    <div class="custom-control custom-radio right mx-1">
                      <input type="radio" class="custom-control-input active" id="showDownloadableTableDataRadio" :value="true" v-model="isShowDownloadableTableDataRadioActive">
                      <label class="custom-control-label" name="showDownloadableOrMergedTableDataRadio" for="showDownloadableTableDataRadio">Show Downloadable Table Data</label>
                    </div>
                    <div class="custom-control custom-radio right mx-1">
                      <input type="radio" class="custom-control-input" id="showMergedTableDataRadio" :value="false" v-model="isShowDownloadableTableDataRadioActive">
                      <label class="custom-control-label" name="showDownloadableOrMergedTableDataRadio" for="showMergedTableDataRadio">Show Merged Table Data</label>
                    </div>
                  </div>
                  <div class="justify-content-end">
                    <div class="custom-control custom-switch right mx-1 justify-content-end row mt-1 p-0 d-none">
                      <input type="checkbox" class="custom-control-input" id="mergeCeaSwitch" :disabled="isShowDownloadableTableDataRadioActive" v-model="isMergeCeaSwitchActive">
                      <label class="custom-control-label col-12 mt-1 pl-5 mr-5 pr-5 pr-sm-0" for="mergeCeaSwitch">CEA:</label>
                    </div>
                    <div class="custom-control custom-switch right mx-1 justify-content-end row mt-1 p-0">
                      <input type="checkbox" class="custom-control-input" id="mergeCtaSwitch" :disabled="isShowDownloadableTableDataRadioActive" v-model="isMergeCtaSwitchActive">
                      <label class="custom-control-label col-12 mt-1 pl-5 mr-5 pr-5 pr-sm-0" for="mergeCtaSwitch">CTA:</label>
                    </div>
                    <div class="custom-control custom-switch right mx-1 justify-content-end row mt-1 p-0">
                      <input type="checkbox" class="custom-control-input" id="mergeCpaSwitch" :disabled="isShowDownloadableTableDataRadioActive" v-model="isMergeCpaSwitchActive">
                      <label class="custom-control-label col-12 mt-1 pl-5 mr-5 pr-5 pr-sm-0" for="mergeCpaSwitch">CPA:</label>
                    </div>
                    <div class="custom-control custom-switch right mx-1 justify-content-end row mt-1 p-0">
                      <input type="checkbox" class="custom-control-input" id="mergeScoresSwitch" :disabled="isShowDownloadableTableDataRadioActive" v-model="isMergeScoresSwitchActive">
                      <label class="custom-control-label col-12 mt-1 pl-5 mr-5 pr-5 pr-sm-0" for="mergeScoresSwitch">Scores:</label>
                    </div>
                  </div>

                </div>
              </div>
            </fieldset>
            <fieldset class="border border-600 px-2 pb-1 my-1 text-left rounded">
              <legend class="pl-2">Filters Options</legend>
              <div class="col justify-content-end">
                <div class="row mx-1 justify-content-end">
                  <label class="align-middle mt-1 mr-3">Active filter:</label>
                  <div v-if="filterCoordinates !== undefined" class="pr-1 pl-1 mb-1 row rounded rounded-4 align-middle bg-info">
                    <span class="pt-1 pb-1 font-weight-bold">{{ filterName }}</span>
                    <span title="Delete filter" class="pt-1 pb-1 float-right ml-1 clickable align-top" v-on:click="filterCoordinates = undefined">x</span>
                  </div>
                  <div v-if="filterCoordinates === undefined" class="pr-1 pl-1 mb-1 row rounded align-middle bg-light">
                    <span class="pt-1 pb-1 font-weight-bold">{{ `none` }}</span>
                  </div>
                </div>
              </div>
            </fieldset>
            <fieldset class="border border-600 px-2 pb-1 my-1 text-left rounded form-group">
              <legend class="pl-2">Knowledge Graph Options</legend>
              <div class="col justify-content-end">
                <div class="row mx-1 justify-content-end mb-2">
                  <label class="align-left col-12">Minimum CPA Score used for requests:</label>
                  <input type="range" class="custom-range col-6" min="0.01" max="1" step="0.01" id="minCPAScoreForKnowledgeRequestRange" v-model="minCPAScoreForKnowledgeRequest">
                  <input type="number" class="ml-2 col-3" id="minCPAScoreForKnowledgeRequestInput" min="0.01" max="1" step="0.01" v-model="minCPAScoreForKnowledgeRequest">
                </div>
                <div class="row mx-1 justify-content-end mt-1">
                  <label class="align-middle mt-1 mr-2 col">Results color:</label>
                  <input type="color" id="knowledgeGraphResultsColorPicker" v-model="knowledgeGraphResultsColor">
                </div>
                
                <div class="custom-control custom-switch right mx-1 justify-content-end row mt-1 p-0">
                  <input type="checkbox" class="custom-control-input" id="autoSelectUniquResultAsFavoriteSwitch" v-on:change="autoSelectUniquResultAsFavoriteIsChanged()" v-model="autoSelectUniquResultAsFavorite">
                  <label class="custom-control-label col-12 mt-1 mr-2 pr-3 pr-sm-0" for="autoSelectUniquResultAsFavoriteSwitch">Set uniq results as favorite:</label>
                </div>
              
              </div>
            </fieldset>
            <fieldset class="border border-600 px-2 pb-1 my-1 text-left rounded form-group">
              <legend class="pl-2">Revised Table Data</legend>
              <div class="col-12 justify-content-end">
                <label class="col-12 mt-1 mr-5 pr-5 pr-sm-0" for="autoSelectUniquResultAsFavoriteSwitch">Knowledge results aggregation:</label>
                
                <div class="custom-control custom-switch right mx-1 justify-content-end row mt-1 p-0">
                  <input type="checkbox" class="custom-control-input" id="displayKnowledgeAddedColumnsInRevisedTableDataSwitch" v-model="displayKnowledgeAddedColumnsInRevisedTableData">
                  <label class="custom-control-label col-12 mt-1 pl-5 mr-5 pr-5 pr-sm-0" for="displayKnowledgeAddedColumnsInRevisedTableDataSwitch">Added columns:</label>
                </div>
              
                <div class="custom-control custom-switch right mx-1 justify-content-end row mt-1 p-0">
                  <input type="checkbox" class="custom-control-input" id="displayKnowledgeFavoriteResultsInRevisedTableDataSwitch" v-model="displayKnowledgeFavoriteResultsInRevisedTableData">
                  <label class="custom-control-label col-12 mt-1 pl-5 mr-2 pr-3 pr-sm-0" for="displayKnowledgeFavoriteResultsInRevisedTableDataSwitch">Favorite results:</label>
                </div>
              
              </div>
            </fieldset>



          </div>

        </template>
      </SideMenuDisplayer>

    </div>
    <a v-if="(isInProgress === true)" class="mb-4 mt-3 ml-2 btn btn-sm btn-secondary" v-on:click="onRefreshTableAnnotationStatus">{{ 'Refresh Annotation Status' }}</a>

    <div v-if="(isInProgress === false) && ((displayedPreProcessingResult === undefined) || (displayedAnnotationContent === undefined))" id="EmptyAnnotationTablesDataContent" class="justify-content-around row col-12 mb-3">
      <TableContentDisplayer v-if="displayedPreProcessingResult === undefined" class="" :orientation="'HORIZONTAL'" :hasHeader="true" :headerPosition="0" :tableContentDisplayerTitle="'Empty PreProcessed Table Data'" :tableToDisplay="[['<empty table data>']]"></TableContentDisplayer>
      <TableContentDisplayer v-if="displayedAnnotationContent === undefined" class="" :orientation="'HORIZONTAL'" :hasHeader="true" :headerPosition="0" :tableContentDisplayerTitle="'Empty Annotation Content'" :tableToDisplay="[['<empty annotation>']]"></TableContentDisplayer>
    </div>

    <div v-if="(displayedPreProcessingResult !== undefined) && (displayedAnnotationContent !== undefined)" id="AnnotationTablesDataContent" class="row col-12">
      <div class="col"></div>
      <!--
      <TableContentDisplayer v-if="!withMergedRevisedTableData" class="" :orientation="PreProcessingResultOrientation" :hasHeader="PreProcessingResultHasHeader" :headerPosition="PreProcessingResultHeaderPosition" :tableContentDisplayerTitle="'Revised Table Data'" :tableMatrixToDisplay="PreProcessingResultTableDataRevisedMatrix" :repeatHeaderInArrayContent="false" v-bind:hoverCoordinates="hoverCoordinates" v-on:hover-changed="onHoverCoordinatesChanged($event)" v-bind:filterCoordinates="filterCoordinates"></TableContentDisplayer>
      -->
      <MergedAnnotationTablesDisplayer v-if="!withMergedRevisedTableData"
          :mergeOptions="defaultMergeOption"
          :orientation="PreProcessingResultOrientation"
          :hasHeader="PreProcessingResultHasHeader"
          :headerPosition="PreProcessingResultHeaderPosition"
          :tableContentDisplayerTitle="'Revised Table Data'"
          :dataTableMatrixToMerge="PreProcessingResultTableDataRevisedMatrix"
          :ceaTableMatrixToMerge="CEATableMatrix"
          :ctaTableMatrixToMerge="CTATableMatrix"
          :cpaTableMatrixToMerge="CPATableMatrix"
          :addedColumnsMatrix="addedColumnsMatrixForTextTable"
          :addedColumnsPropertiesMatrix="addedColumnsPropertiesMatrix"
          :addedColumnsProperties="displayKnowledgeAddedColumnsInRevisedTableData ? addedColumnsProperties : []"
          :displayedKnowledgeResults="displayedKnowledgeResultsForTextTable"
          :repeatHeaderInArrayContent="false"
          :knowledgeGraphResultsColor="knowledgeGraphResultsColor"
          :minCPAScoreForKnowledgeRequest="minCPAScoreForKnowledgeRequest"
          v-bind:hoverCoordinates="hoverCoordinates"
          v-bind:filterCoordinates="filterCoordinates"
          v-on:hover-changed="onHoverCoordinatesChanged($event)"
          v-on:add-new-property-column="onAddNewPropertyColumn($event)"
          v-on:find-knowledge-graph-results="onFindCeas($event)"
          v-on:select-favorite-knowledge-graph-result="onSelectFavoriteKnowledgeGraphResult($event)"
          v-on:unselect-favorite-knowledge-graph-result="onUnselectFavoriteKnowledgeGraphResult($event)"
          v-on:save-additional-content="onSaveAdditionalContent($event)"
          v-on:remove-additional-content="onRemoveAdditionalContent($event)">
      </MergedAnnotationTablesDisplayer>
      
      <MergedAnnotationTablesDisplayer v-if="withMergedRevisedTableData"
          :mergeOptions="mergeOptions"
          :orientation="PreProcessingResultOrientation"
          :hasHeader="PreProcessingResultHasHeader"
          :headerPosition="PreProcessingResultHeaderPosition"
          :tableContentDisplayerTitle="'Merged and Revised Table Data'"
          :dataTableMatrixToMerge="PreProcessingResultTableDataRevisedMatrix"
          :ceaTableMatrixToMerge="CEATableMatrix"
          :ctaTableMatrixToMerge="CTATableMatrix"
          :cpaTableMatrixToMerge="CPATableMatrix"
          :addedColumnsMatrix="addedColumnsMatrix"
          :addedColumnsPropertiesMatrix="addedColumnsPropertiesMatrix"
          :addedColumnsProperties="displayKnowledgeAddedColumnsInRevisedTableData ? addedColumnsProperties : []"
          :displayedKnowledgeResults="displayedKnowledgeResults"
          :repeatHeaderInArrayContent="false"
          :knowledgeGraphResultsColor="knowledgeGraphResultsColor"
          :minCPAScoreForKnowledgeRequest="minCPAScoreForKnowledgeRequest"
          v-bind:hoverCoordinates="hoverCoordinates"
          v-bind:filterCoordinates="filterCoordinates"
          v-on:hover-changed="onHoverCoordinatesChanged($event)"
          v-on:add-new-property-column="onAddNewPropertyColumn($event)"
          v-on:find-knowledge-graph-results="onFindCeas($event)"
          v-on:select-favorite-knowledge-graph-result="onSelectFavoriteKnowledgeGraphResult($event)"
          v-on:unselect-favorite-knowledge-graph-result="onUnselectFavoriteKnowledgeGraphResult($event)"
          v-on:save-additional-content="onSaveAdditionalContent($event)"
          v-on:remove-additional-content="onRemoveAdditionalContent($event)">
      </MergedAnnotationTablesDisplayer>
      <div class="col"></div>
    </div>

    <div v-if="displayedAnnotationContent !== undefined" id="AnnotationContent" class="justify-content-around row col-12 mb-3">
      <TableContentDisplayer v-if="isShowDownloadableTableDataRadioActive || !isMergeCeaSwitchActive" class="mr-1 ml-1" :orientation="'HORIZONTAL'" :hasHeader="true" :headerPosition="0" :tableContentDisplayerTitle="'CEA'" :tableMatrixToDisplay="CEATableMatrix" :repeatHeaderInArrayContent="false" :maxHeight="'250px'" :isCEA="true" v-bind:hoverCoordinates="hoverCoordinates" v-on:hover-changed="onHoverCoordinatesChanged($event)" v-bind:filterCoordinates="filterCoordinates"></TableContentDisplayer>
      <TableContentDisplayer v-if="isShowDownloadableTableDataRadioActive || !isMergeCtaSwitchActive" class="mr-1 ml-1" :orientation="'HORIZONTAL'" :hasHeader="true" :headerPosition="0" :tableContentDisplayerTitle="'CTA'" :tableMatrixToDisplay="CTATableMatrix" :repeatHeaderInArrayContent="false" :maxHeight="'250px'" :isCTA="true" v-bind:hoverCoordinates="hoverCoordinates" v-on:hover-changed="onHoverCoordinatesChanged($event)" v-bind:filterCoordinates="filterCoordinates"></TableContentDisplayer>
      <TableContentDisplayer v-if="isShowDownloadableTableDataRadioActive || !isMergeCpaSwitchActive" class="mr-1 ml-1" :orientation="'HORIZONTAL'" :hasHeader="true" :headerPosition="0" :tableContentDisplayerTitle="'CPA'" :tableMatrixToDisplay="CPATableMatrix" :repeatHeaderInArrayContent="false" :maxHeight="'250px'" :isCPA="true" v-bind:hoverCoordinates="hoverCoordinates" v-on:hover-changed="onHoverCoordinatesChanged($event)" v-bind:filterCoordinates="filterCoordinates"></TableContentDisplayer>
    </div>

  </div>

</template>
<script>
import TableContentDisplayer from "./TableContentDisplayer";
import MergedAnnotationTablesDisplayer from "./MergedAnnotationTablesDisplayer";
import SideMenuDisplayer from "../../menu/SideMenuDisplayer";
import TableMatrix from '../../../model/TableMatrix';
import KnowledgeGraphApi from "../../../generatedApiClient/api/endpoints/KnowledgeGraphApi";
import TableApi from "../../../generatedApiClient/api/endpoints/TableApi";
// import ArrayUtils from '../../../utils/ArrayUtils';
import MessageDisplayerService from '../../../utils/MessageDisplayerService';

import configuredProjectsJobs from './projectsJobs.json';

let knowledgeGraphApiInstance = new KnowledgeGraphApi();
let tableApiInstance = new TableApi();

 // import ProgressBar from '@/components/global/ProgressBar.vue'

export default {
  name: "AnnotationResultDisplayer",
  components: {
    TableContentDisplayer,
    MergedAnnotationTablesDisplayer,
    SideMenuDisplayer,
    //ProgressBar
  },
  props: ["tableId", "AnnotationContent", "PreProcessingResult", "isInProgress", "tableStatus"],
  data() {
    return {
      hoverCoordinates: undefined,
      filterCoordinates: undefined,
      isShowDownloadableTableDataRadioActive: false,
      isMergeScoresSwitchActive: true,
      isMergeCeaSwitchActive: true,
      isMergeCtaSwitchActive: true,
      isMergeCpaSwitchActive: true,
      knowledgeGraphResultsColor: '#0d86e2',
      minCPAScoreForKnowledgeRequest: 0.01,
      autoSelectUniquResultAsFavorite: true,
      displayKnowledgeAddedColumnsInRevisedTableData: true,
      displayKnowledgeFavoriteResultsInRevisedTableData: true,
      addedColumns: [],
      addedColumnsProperties: [],
      displayedKnowledgeResults: [],
      defaultMergeOption: {isCeaMerged: false, isCtaMerged: false, isCpaMerged: false, displayedAsTextTable: true}
    }
  },
  mounted() {
    this.loadAdditionalContent();
  },
  computed: {
    mergeOptions: function() {
      if (this.isShowDownloadableTableDataRadioActive) {
        return {
          isScoresMerged: this.isMergeScoresSwitchActive,
          isCeaMerged: false,
          isCtaMerged: false,
          isCpaMerged: false
        }
      } else {
        return {
          isScoresMerged: this.isMergeScoresSwitchActive,
          isCeaMerged: this.isMergeCeaSwitchActive,
          isCtaMerged: this.isMergeCtaSwitchActive,
          isCpaMerged: this.isMergeCpaSwitchActive
        }
      }
    },
    withMergedRevisedTableData: function() {
      return !this.isShowDownloadableTableDataRadioActive && (this.isMergeCeaSwitchActive || this.isMergeCtaSwitchActive || this.isMergeCpaSwitchActive);
    },
    showLoadingButton: function() {
      return (this.tableStatus === undefined) || ( (this.isInProgress === false) && (this.displayedAnnotationContent === undefined) && ['ANNOTATION IN PROGRESS', 'ANNOTATION DONE'].includes(this.tableStatus) );
    },
    launchOrRestartAnnotationButtonText: function() {
      if (['UPLOADED', 'PRE PROCESSING IN PROGRESS', 'PRE PROCESSING IN ERROR', 'PRE PROCESSING FAILED', 'PRE PROCESSING DONE', 'ANNOTATION IN PROGRESS'].includes(this.tableStatus) && (this.AnnotationContent === undefined)) {
        return 'Start Annotation';
      } else {
        return 'Restart Annotation';
      }
    },
    displayedPreProcessingResult: function() {
      if ((this.PreProcessingResult !== undefined) && (this.PreProcessingResult[0] !== undefined)) {
        return this.PreProcessingResult[0];
      } else {
        return undefined;
      }
    },
    displayedAnnotationContent: function() {
      if ((this.AnnotationContent !== undefined) && (this.AnnotationContent[0] !== undefined)) {
        return this.AnnotationContent[0];
      } else {
        return undefined;
      }
    },
    filterName: function() {
      if (this.filterCoordinates.row !== undefined) {
        return `Row ${this.filterCoordinates.row}`;
      } else {
        if (this.filterCoordinates.columnLinked !== undefined) {
          return `Columns ${this.filterCoordinates.column} and ${this.filterCoordinates.columnLinked}`;
        } else {
          return `Column ${this.filterCoordinates.column}`;
        }
      }
    },
    CEAArray: function() {
      const returnedCEAArray = [];
      returnedCEAArray[0] = ["Row", "Column", "ID", "Label", "Score"];
      if (this.displayedAnnotationContent !== undefined) {
        this.displayedAnnotationContent.annotated.CEA.forEach(element => {
          const splittedUris = element.annotation.uri.split('::');
          let transformedLabel = '';
          splittedUris.forEach((splittedUri) => {
            const splittedUriWithoutHeader = splittedUri.replace(/^(\(-\)|)http/g, 'http');
            const splittedUriHeader = splittedUri.replace(/^(\(-\)|)http(.*)/g, '$1');
            // const splittedUriQid = splittedUri.replace(/^(\(-\)|)http(.*)(\/([^/])?)/g, '$4');
            const splittedUriQid = splittedUri.replace(/^(\(-\)|)http(.*)(\/(Property:|)([^/])?)/g, '$5');
            const splittedUriTransformedLabel = `<a href="${splittedUriWithoutHeader}" target="_blank">${splittedUriQid}</a>`;
            transformedLabel += (transformedLabel === '') ? '' : '::'
            transformedLabel += `${splittedUriHeader}${splittedUriTransformedLabel}`;
          });
          const label = element.annotation.label;
          const lineArray = [element.row, element.column, transformedLabel, label, element.annotation.score.toFixed(2)];
          returnedCEAArray.push(lineArray);
        });
      }
      return returnedCEAArray;
    },
    CPAArray: function() {
      const returnedCPAArray = [];
      returnedCPAArray[0] = ["Head", "Tail", "ID", "Label", "Score", "Coverage"];
      if (this.displayedAnnotationContent !== undefined) {
        this.displayedAnnotationContent.annotated.CPA.forEach(element => {
          const splittedUris = element.annotation.uri.split('::');
          let transformedLabel = '';
          splittedUris.forEach((splittedUri) => {
            const splittedUriWithoutHeader = splittedUri.replace(/^(\(-\)|)http/g, 'http');
            const splittedUriHeader = splittedUri.replace(/^(\(-\)|)http(.*)/g, '$1');
            // const splittedUriQid = splittedUri.replace(/^(\(-\)|)http(.*)(\/([^/])?)/g, '$4');
            const splittedUriQid = splittedUri.replace(/^(\(-\)|)http(.*)(\/(Property:|)([^/])?)/g, '$5');
            const splittedUriTransformedLabel = `<a href="${splittedUriWithoutHeader}" target="_blank">${splittedUriQid}</a>`;
            transformedLabel += (transformedLabel === '') ? '' : '::'
            transformedLabel += `${splittedUriHeader}${splittedUriTransformedLabel}`;
          });
          const label = element.annotation.label;
          const lineArray = [element.headColumn, element.tailColumn, transformedLabel, label, element.annotation.score.toFixed(2), element.annotation.coverage.toFixed(2)];
          returnedCPAArray.push(lineArray);
        });
      }
      return returnedCPAArray;
    },
    CTAArray: function() {
      const returnedCTAArray = [];
      returnedCTAArray[0] = ["Column", "ID", "Label", "Score", "Coverage"];
      if (this.displayedAnnotationContent !== undefined) {
        this.displayedAnnotationContent.annotated.CTA.forEach(element => {
          const elementAnnotation = element.annotation[0];
          const splittedUris = elementAnnotation.uri.split('::');
          let transformedLabel = '';
          splittedUris.forEach((splittedUri) => {
            const splittedUriWithoutHeader = splittedUri.replace(/^(\(-\)|)http/g, 'http');
            const splittedUriHeader = splittedUri.replace(/^(\(-\)|)http(.*)/g, '$1');
            // const splittedUriQid = splittedUri.replace(/^(\(-\)|)http(.*)(\/([^/])?)/g, '$4');
            const splittedUriQid = splittedUri.replace(/^(\(-\)|)http(.*)(\/(Property:|)([^/])?)/g, '$5');
            const splittedUriTransformedLabel = `<a href="${splittedUriWithoutHeader}" target="_blank">${splittedUriQid}</a>`;
            transformedLabel += (transformedLabel === '') ? '' : '::'
            transformedLabel += `${splittedUriHeader}${splittedUriTransformedLabel}`;
          });
          const label = elementAnnotation.label;
          const lineArray = [element.column, transformedLabel, label, elementAnnotation.score.toFixed(2), elementAnnotation.coverage.toFixed(2)];
          returnedCTAArray.push(lineArray);
        });
      }
      return returnedCTAArray;
    },
    CEATableMatrix: function() {
      return new TableMatrix(this.CEAArray);
    },
    CPATableMatrix: function() {
      return new TableMatrix(this.CPAArray);
    },
    CTATableMatrix: function() {
      return new TableMatrix(this.CTAArray);
    },
    addedColumnsMatrix: function() {
      console.log("[TEST] addedColumnsMatrix");
      return new TableMatrix(this.addedColumns);
    },
    addedColumnsPropertiesMatrix: function() {
      // console.log("[TEST] addedColumnsPropertiesMatrix");
      return new TableMatrix(this.addedColumnsProperties);
    },
    addedColumnsMatrixForTextTable: function() {
      return (this.displayKnowledgeAddedColumnsInRevisedTableData) ? this.addedColumnsMatrix : new TableMatrix([]);
    },
    displayedKnowledgeResultsForTextTable: function() {
      return (this.displayKnowledgeFavoriteResultsInRevisedTableData) ? this.displayedKnowledgeResults : [];
    },
    isPreProcessingResultDefined: function() {
      return (this.PreProcessingResult !== undefined) && (Array.isArray(this.PreProcessingResult)) && (this.PreProcessingResult[0] !== undefined);
    },
    PreProcessingResultOrientation: function() {
      return this.isPreProcessingResultDefined ? this.PreProcessingResult[0].preprocessed.tableOrientation.orientationLabel : undefined;
    },
    PreProcessingResultHasHeader: function() {
      return this.isPreProcessingResultDefined ? this.PreProcessingResult[0].preprocessed.headerInfo.hasHeader : undefined;
    },
    PreProcessingResultHeaderPosition: function() {
      return this.isPreProcessingResultDefined ? this.PreProcessingResult[0].preprocessed.headerInfo.headerPosition : undefined;
    },
    PreProcessingResultHeader: function() {
      return this.PreProcessingResultHasHeader ? this.PreProcessingResultTableDataRevisedMatrix.getRow(this.PreProcessingResultHeaderPosition) : undefined;
    },
    PreProcessingResultTableDataRawMatrix: function() {
      return this.isPreProcessingResultDefined ? new TableMatrix(this.PreProcessingResult[0].raw.tableDataRaw) : new TableMatrix(undefined);
    },
    PreProcessingResultTableDataRevisedMatrix: function() {
      return this.isPreProcessingResultDefined ? new TableMatrix(this.PreProcessingResult[0].preprocessed.tableDataRevised) : new TableMatrix(undefined);
    },
    signedUser: function() {
      return (this.$store.state.identityIdentified !== undefined) ? this.$store.state.identityIdentified.email : undefined;
    },
    selectedProjectId: function() {
      return (this.$store.state.selectedProject !== undefined) ? this.$store.state.selectedProject.id : undefined;
    },
    selectedProjectName: function() {
      return (this.$store.state.selectedProject !== undefined) ? this.$store.state.selectedProject.name : undefined;
    },
  },
  methods: {
    updateAuthJwtToken: function (apiInstance) {
      if (apiInstance && apiInstance.apiClient && apiInstance.apiClient.authentications && apiInstance.apiClient.authentications['AuthJWT']) {
        apiInstance.apiClient.authentications['AuthJWT'].accessToken = this.$store.state.identityIdentified.token;
      }
    },
    isHeaderLine: function(index) {
      // console.log("[TEST] isHeaderLine");
      let result = false;
      if ((this.PreProcessingResultOrientation === 'HORIZONTAL') && (this.PreProcessingResultHasHeader === true) && (this.PreProcessingResultHeaderPosition === index)) {
        result = true;
      } else {
        result = false;
      }
      return result;
    },
    isHeaderPositionWithoutHeaderLine: function(index) {
      // console.log("[TEST] isHeaderPositionWithoutHeaderLine");
      let result = false;
      if ((this.PreProcessingResultHasHeader === false) && (this.PreProcessingResultHeaderPosition === index)) {
        result = true;
      } else {
        result = false;
      }
      return result;
    },
    autoSelectUniquResultAsFavoriteIsChanged: function() {
      console.log("autoSelectUniquResultAsFavoriteIsChanged : ", this.autoSelectUniquResultAsFavorite);
      if (this.autoSelectUniquResultAsFavorite) {
        // Do something to define. Maybe emit an event? Or launch action in local array? 
        const updatedDisplayedKnowledgeResults = this.displayedKnowledgeResults.map(displayedKnowledgeResult => {
          if (displayedKnowledgeResult.foundCeas.length === 1) {
            // Auto select this result as favorite
            displayedKnowledgeResult.foundCeas = displayedKnowledgeResult.foundCeas.map(foundCea => {
              foundCea.isFavorite = true;
              return foundCea;
            })
          }
          return displayedKnowledgeResult;
        });
        this.displayedKnowledgeResults = updatedDisplayedKnowledgeResults;
      }
    },
    onHoverCoordinatesChanged: function(newCoordinates) {
      this.hoverCoordinates = newCoordinates;
    },
    /*
    onFilterCoordinatesChanged: function(newCoordinates) {
      this.filterCoordinates = newCoordinates;
    },
    */
    onResetFilterCoordinates: function() {
      this.filterCoordinates = undefined;
    },
    onStartTableAnnotation: function() {
      console.log("[onStartTableAnnotation] -~~-> start-table-annotation");
      this.$emit('start-table-annotation');
    },
    onRefreshTableAnnotationStatus: function() {
      console.log("[onRefreshTableAnnotationStatus] -~~-> refresh-table-annotation-status");
      this.$emit('refresh-table-annotation-status');
    },
    refreshAddedPropertyColumnInDisplay: function() {
      console.log("[TEST] refreshAddedPropertyColumnInDisplay");
      this.addedColumns = this.addedColumns.filter(() => true);
    },
    onAddNewPropertyColumn: function (event) {
      console.log("[TEST] onAddNewPropertyColumn");
      console.log("[onAddNewPropertyColumn] event = ", JSON.stringify(event));
      this.addedColumnsProperties.push({
        linkedColumnIndex: event.startColumnIndex,
        propertyLabel: event.property.pLabel,
        propertyUri: event.property.p
      });
      let addedColumnsCreatedIndex = undefined;
      this.PreProcessingResultTableDataRevisedMatrix.getColumn(event.startColumnIndex).forEach((row, rowIndex) => {
        if (this.addedColumns[rowIndex] === undefined) {
          this.addedColumns[rowIndex] = [];
        }
        if (this.isHeaderLine(rowIndex) || this.isHeaderPositionWithoutHeaderLine(rowIndex)) {
          this.addedColumns[rowIndex].push(event.headerName);
        } else {
          const pushIndex = this.addedColumns[rowIndex].push('');
          if (addedColumnsCreatedIndex === undefined) {
            addedColumnsCreatedIndex = pushIndex - 1;
          }
        }
      });
      this.refreshAddedPropertyColumnInDisplay();
      // console.log("[onAddNewPropertyColumn] this.addedColumns = ", JSON.stringify(this.addedColumns));
      // console.log("[onAddNewPropertyColumn] addedColumnsCreatedIndex = ", JSON.stringify(addedColumnsCreatedIndex));
      const displayedKnowledgeResultsColumnSelector = { addedColumnIndex: addedColumnsCreatedIndex }; 
      this.findAllCeasInAddedPropertiesColumn(displayedKnowledgeResultsColumnSelector);
    },
    findAllCeasInAddedPropertiesColumn: function(columnSelector) {
      console.log("[findAllCeasInAddedPropertiesColumn] columnSelector = ", columnSelector);
      this.PreProcessingResultTableDataRevisedMatrix.getRows().forEach((row, rowIndex) => {
        this.removeAndWaitKnowledgeResultInDisplayedKnowledgeResults(rowIndex, columnSelector);
      });
      const addedColumnIndex = columnSelector.addedColumnIndex;

      const addedColumnsProperty = this.addedColumnsProperties[addedColumnIndex];
      if (addedColumnsProperty === undefined) {
        console.log(`[findAllCeasInAddedPropertiesColumn] addedColumnsProperty is undefined for index ${addedColumnIndex} - this.addedColumnsProperties ${JSON.stringify(this.addedColumnsProperties)}`);
        return;
      }
      const linkedColumnIndex = addedColumnsProperty.linkedColumnIndex;
      const propertyLabel = addedColumnsProperty.propertyLabel;
      const propertyUri = addedColumnsProperty.propertyUri;

      const linkedColumnIndexCEAs = this.displayedAnnotationContent.annotated.CEA.filter(element => {
        return (element.column === linkedColumnIndex)
      });
      
      const headCeas = this.PreProcessingResultTableDataRevisedMatrix.getRows() //.filter((row, rowIndex) => rowIndex < 200)
      .map((row, rowIndex) => {
        const CEA = linkedColumnIndexCEAs.find(element => {
          return ((element.row === rowIndex) && (element.column === linkedColumnIndex))
        });

        if (CEA && CEA.annotation) {
          return {
            columnIndex: linkedColumnIndex,
            label: CEA.annotation.label,
            uri: CEA.annotation.uri
          };
        } else {
          return undefined
        }
      });

      const findKnowledgeGraphRelationshipValuesRequest = {
        cpa: {
          headIndex: linkedColumnIndex,
          tailIndex: -1 - addedColumnIndex,
          label: propertyLabel,
          uri: propertyUri ? propertyUri.replaceAll(new RegExp(/<a href="([^"]*)"([^<]*)<\/a>/g), '$1') : undefined
        },
        headCeas
      }

      this.updateAuthJwtToken(knowledgeGraphApiInstance);
      knowledgeGraphApiInstance.findKnowledgeGraphRelationshipValues(findKnowledgeGraphRelationshipValuesRequest)
        .then(findKnowledgeGraphRelationshipValuesResp => {
          console.log("[findCeas] [API] [findKnowledgeGraphRelationshipValues] [OK]");
          console.log("[findCeas] findKnowledgeGraphRelationshipValuesResp = ", JSON.stringify(findKnowledgeGraphRelationshipValuesResp));

          findKnowledgeGraphRelationshipValuesResp.tailCeas.forEach((tailCea, tailCeaIndex) => {
            const isFavoriteDefaultValue = (tailCea.foundKnowledgeGraphValues.length === 1) && this.autoSelectUniquResultAsFavorite;

            this.addKnowledgeResultInDisplayedKnowledgeResults({
              lineIndex: tailCeaIndex,
              columnSelector,
              foundCeas: tailCea.foundKnowledgeGraphValues.map(foundKnowledgeGraphValue => {
                const splittedUris = foundKnowledgeGraphValue.item.split('::');
                let foundCeaLink = '';
                if (foundKnowledgeGraphValue.isItemProperty) {
                  splittedUris.forEach((splittedUri) => {
                    const splittedUriWithoutHeader = splittedUri.replace(/^(\(-\)|)http/g, 'http');
                    const splittedUriHeader = splittedUri.replace(/^(\(-\)|)http(.*)/g, '$1');
                    // const splittedUriQid = splittedUri.replace(/^(\(-\)|)http(.*)(\/([^/])?)/g, '$4');
                    const splittedUriQid = splittedUri.replace(/^(\(-\)|)http(.*)(\/(Property:|)([^/])?)/g, '$5');
                    const splittedUriTransformedLabel = `<a href="${splittedUriWithoutHeader}" target="_blank">${splittedUriQid}</a>`;
                    foundCeaLink += (foundCeaLink === '') ? '' : '::'
                    foundCeaLink += `${splittedUriHeader}${splittedUriTransformedLabel}`;
                  });
                } else if ((foundKnowledgeGraphValue.isUrlProperty) || (foundKnowledgeGraphValue.isMediaProperty)) {
                  foundCeaLink = `<a href="${foundKnowledgeGraphValue.item}" target="_blank">${foundKnowledgeGraphValue.item}</a>`;
                }
                return {
                  label: foundKnowledgeGraphValue.itemLabel,
                  uri: foundKnowledgeGraphValue.item,
                  link: foundCeaLink,
                  isValueProperty: foundKnowledgeGraphValue.isValueProperty,
                  isUrlProperty: foundKnowledgeGraphValue.isUrlProperty,
                  isItemProperty: foundKnowledgeGraphValue.isItemProperty,
                  isMediaProperty: foundKnowledgeGraphValue.isMediaProperty,
                  isFavorite: isFavoriteDefaultValue,
                  matchingCpas: [ { cpa: findKnowledgeGraphRelationshipValuesRequest.cpa } ]
                }
              })
            });
          });

          /*
          findKnowledgeGraphRelationshipValuesResp

          const isFavoriteDefaultValue = (findKnowledgeGraphValuesFromRelationshipsResp.foundKnowledgeGraphValues.length === 1) && this.autoSelectUniquResultAsFavorite;

*/
        })
        .catch(findCeasByCtaError => {
          console.log("[findCeas] [API] [findCeasByCta] [ERROR]", findCeasByCtaError);
          this.PreProcessingResultTableDataRevisedMatrix.getRows().forEach((row, rowIndex) => {
            this.addKnowledgeResultInDisplayedKnowledgeResults({
              lineIndex: rowIndex,
              columnSelector,
              isWaitingKnowledgeResult: false,
              foundCeas: []
            });
          });

        });

      /*
      console.log("[findAllCeasInAddedPropertiesColumn] (columnIndex >= this.PreProcessingResultTableDataRevisedMatrix.getMaxColumnsLength()) = ", (columnIndex >= this.PreProcessingResultTableDataRevisedMatrix.getMaxColumnsLength()))
      const range = 10;
      const splittedMergedTableMatrix = ArrayUtils.splitArray(this.PreProcessingResultTableDataRevisedMatrix.getRows().map((row, rowIndex) => { return {row, rowIndex}}), range);
      splittedMergedTableMatrix.forEach((splittedArray, splittedArrayIndex) => {
        setTimeout(() => {
          for(let i = 0 ; i < range ; i++) {
            if (splittedArray[i] !== undefined) {
              // this.onFindCeas(undefined, splittedArray[i].row, splittedArray[i].rowIndex, columnIndex);
              // this.onFindCeas({ line: splittedArray[i].row, lineIndex: splittedArray[i].rowIndex, columnIndex });
              this.onFindCeas({ line: splittedArray[i].row, lineIndex: splittedArray[i].rowIndex, columnSelector });
            }
          }
        }, 1000 * splittedArrayIndex)
      });
      */
    },
    onFindCeas: function(event) {

      // const givenElement = event.givenElement;
      const line = event.line;
      const lineIndex = event.lineIndex;
      // const initialMaxColumnsLength = this.PreProcessingResultTableDataRevisedMatrix.getMaxColumnsLength();
      // const columnIndex = givenElement.isAddedColumnsPropertyElement ? (initialMaxColumnsLength + givenElement.addedColumnsPropertyIndex) : givenElement.initialColumnIndex;
      const columnSelector = event.columnSelector;

      // console.log("[onFindCeas] columnIndex = ", columnIndex)
      console.log("[onFindCeas] columnSelector = ", columnSelector);

      // First -> delete the already existing KnowledgeResult and define isWaitingKnowledgeResult boolean for this cell
      // this.removeAndWaitKnowledgeResultInDisplayedKnowledgeResults(lineIndex, columnIndex);
      this.removeAndWaitKnowledgeResultInDisplayedKnowledgeResults(lineIndex, columnSelector);
      let columnCpa;
      // console.log("columnIndex = ", columnIndex);
      // console.log("this.dataTableMatrixToMerge.getMaxColumnsLength() = ", this.dataTableMatrixToMerge.getMaxColumnsLength());
      // if (columnIndex >= this.dataTableMatrixToMerge.getMaxColumnsLength()) {
      if (columnSelector.addedColumnIndex !== undefined) {
      
        // This column is a column added from property
        // const addedColumnsIndex = columnIndex - this.PreProcessingResultTableDataRevisedMatrix.getMaxColumnsLength();
        const addedColumnIndex = columnSelector.addedColumnIndex;

        const addedColumnsProperty = this.addedColumnsProperties[addedColumnIndex];
        if (addedColumnsProperty === undefined) {
          console.log(`[onFindCeas] addedColumnsProperty is undefined for index ${addedColumnIndex} - this.addedColumnsProperties ${JSON.stringify(this.addedColumnsProperties)}`);
          return;
        }
        const linkedColumnIndex = addedColumnsProperty.linkedColumnIndex;
        const propertyLabel = addedColumnsProperty.propertyLabel;
        const propertyUri = addedColumnsProperty.propertyUri;

        const CEA = this.displayedAnnotationContent.annotated.CEA.find(element => {
          return ((element.row === lineIndex) && (element.column === linkedColumnIndex))
        });
        // console.log("[lineIndex] = " , lineIndex);
        // console.log("[linkedColumnIndex] = " , linkedColumnIndex);
        // console.log("[CEA] = " , CEA);
        const ceaLabel = (CEA && CEA.annotation) ? CEA.annotation.label : "";
        const ceaUri = (CEA && CEA.annotation) ? CEA.annotation.uri : "";

        console.log(`[CEA] lineIndex ${lineIndex} - columnIndex ${linkedColumnIndex} - CEA ${JSON.stringify(CEA && CEA.annotation)}`);

        columnCpa = [
          {
            headCea: {
              columnIndex: linkedColumnIndex,
              label: ceaLabel,
              uri: ceaUri
//              label: line[linkedColumnIndex].ceaLabel,
//              uri: line[linkedColumnIndex].ceaLink ? line[linkedColumnIndex].ceaLink.replaceAll(new RegExp(/<a href="([^"]*)"([^<]*)<\/a>/g), '$1') : undefined
            },
            cpa: {
              headIndex: linkedColumnIndex,
              tailIndex: -1 - addedColumnIndex,
              label: propertyLabel,
              uri: propertyUri ? propertyUri.replaceAll(new RegExp(/<a href="([^"]*)"([^<]*)<\/a>/g), '$1') : undefined
            }
          }
        ]
        console.log("[findCeas] columnCpa = ", JSON.stringify(columnCpa));
        // launch request here with columnCpa body
      } else {

        const initialColumnIndex = columnSelector.initialColumnIndex;

        // This column is a column from initial table
        columnCpa = this.CPATableMatrix.getRows().filter((cpaRow) => {
            return ((cpaRow[0] === initialColumnIndex) || (cpaRow[1] === initialColumnIndex)) && (cpaRow[4] >= this.minCPAScoreForKnowledgeRequest )
          }).map((cpaFiltered) => {
            // do nothing
            console.log("[onFindCeas] cpaFiltered = ", cpaFiltered);
            // do nothing

            // console.log("[findCeas] line = ", line);
            const linkedLineElement = line.find((lineElement) => {
              if (cpaFiltered[0] === initialColumnIndex) {
                return (lineElement.initialColumnIndex === cpaFiltered[1])
              } else {
                return (lineElement.initialColumnIndex === cpaFiltered[0])
              }
            })
            console.log("[findCeas] linkedLineElement = ", linkedLineElement);

            return {
              headCea: (cpaFiltered[0] === initialColumnIndex) ? undefined : {
                columnIndex: cpaFiltered[0],
                label: linkedLineElement.ceaLabel,
                uri: linkedLineElement.ceaLink ? linkedLineElement.ceaLink.replaceAll(new RegExp(/<a href="([^"]*)"([^<]*)<\/a>/g), '$1') : undefined
              },
              tailCea: (cpaFiltered[1] === initialColumnIndex) ? undefined : {
                columnIndex: cpaFiltered[1],
                label: linkedLineElement.ceaLabel,
                uri: linkedLineElement.ceaLink ? linkedLineElement.ceaLink.replaceAll(new RegExp(/<a href="([^"]*)"([^<]*)<\/a>/g), '$1') : undefined
              },
              cpa: {
                headIndex: cpaFiltered[0],
                tailIndex: cpaFiltered[1],
                label: cpaFiltered[3],
                uri: cpaFiltered[2] ? cpaFiltered[2].replaceAll(new RegExp(/<a href="([^"]*)"([^<]*)<\/a>/g), '$1') : undefined
              }
            };
          }).filter((requestObject) => {
            if (requestObject.headCea === undefined) {
              return (requestObject.tailCea.uri !== undefined) && (requestObject.cpa.uri !== undefined);
            } else {
              return (requestObject.headCea.uri !== undefined) && (requestObject.cpa.uri !== undefined);
            }
          });
        console.log("[findCeas] columnCpa = ", JSON.stringify(columnCpa));
        // launch request here with columnCpa body
      }

      this.updateAuthJwtToken(knowledgeGraphApiInstance);
      knowledgeGraphApiInstance.findKnowledgeGraphValuesFromRelationships(columnCpa)
        .then(findKnowledgeGraphValuesFromRelationshipsResp => {
          console.log("[findCeas] [API] [findKnowledgeGraphValuesFromRelationships] [OK]");
          console.log("[findCeas] findKnowledgeGraphValuesFromRelationshipsResp = ", JSON.stringify(findKnowledgeGraphValuesFromRelationshipsResp));

          const isFavoriteDefaultValue = (findKnowledgeGraphValuesFromRelationshipsResp.foundKnowledgeGraphValues.length === 1) && this.autoSelectUniquResultAsFavorite;

          this.addKnowledgeResultInDisplayedKnowledgeResults({
            lineIndex,
            columnSelector,
            foundCeas: findKnowledgeGraphValuesFromRelationshipsResp.foundKnowledgeGraphValues.map(foundKnowledgeGraphValue => {
              const splittedUris = foundKnowledgeGraphValue.item.split('::');
              let foundCeaLink = '';
              if (foundKnowledgeGraphValue.isItemProperty) {
                splittedUris.forEach((splittedUri) => {
                  const splittedUriWithoutHeader = splittedUri.replace(/^(\(-\)|)http/g, 'http');
                  const splittedUriHeader = splittedUri.replace(/^(\(-\)|)http(.*)/g, '$1');
                  // const splittedUriQid = splittedUri.replace(/^(\(-\)|)http(.*)(\/([^/])?)/g, '$4');
                  const splittedUriQid = splittedUri.replace(/^(\(-\)|)http(.*)(\/(Property:|)([^/])?)/g, '$5');
                  const splittedUriTransformedLabel = `<a href="${splittedUriWithoutHeader}" target="_blank">${splittedUriQid}</a>`;
                  foundCeaLink += (foundCeaLink === '') ? '' : '::'
                  foundCeaLink += `${splittedUriHeader}${splittedUriTransformedLabel}`;
                });
              } else if ((foundKnowledgeGraphValue.isUrlProperty) || (foundKnowledgeGraphValue.isMediaProperty)) {
                foundCeaLink = `<a href="${foundKnowledgeGraphValue.item}" target="_blank">${foundKnowledgeGraphValue.item}</a>`;
              }
              return {
                label: foundKnowledgeGraphValue.itemLabel,
                uri: foundKnowledgeGraphValue.item,
                link: foundCeaLink,
                isValueProperty: foundKnowledgeGraphValue.isValueProperty,
                isUrlProperty: foundKnowledgeGraphValue.isUrlProperty,
                isItemProperty: foundKnowledgeGraphValue.isItemProperty,
                isMediaProperty: foundKnowledgeGraphValue.isMediaProperty,
                isFavorite: isFavoriteDefaultValue,
                matchingCpas: foundKnowledgeGraphValue.indexesOfRelationshipsFound.map(indexOfRelationshipsFound => {
                  return {
                    cpa: findKnowledgeGraphValuesFromRelationshipsResp.requestReceived[indexOfRelationshipsFound].cpa
                  };
                })
              }
            })
          });
        })
        .catch(findCeasByCtaError => {
          console.log("[findCeas] [API] [findCeasByCta] [ERROR]", findCeasByCtaError);
          this.addKnowledgeResultInDisplayedKnowledgeResults({
            lineIndex,
            columnSelector,
            isWaitingKnowledgeResult: false,
            foundCeas: []
          });
        });
    },
    areSameColumnSelectors: function(columnSelector1, columnSelector2) {
      if ((columnSelector1 === undefined) || (columnSelector2 === undefined)) {
        return false
      } else if ((columnSelector1.addedColumnIndex !== undefined) && (columnSelector1.initialColumnIndex === undefined)) {
        return ((columnSelector2.initialColumnIndex === undefined) && (columnSelector1.addedColumnIndex === columnSelector2.addedColumnIndex));
      } else if ((columnSelector1.initialColumnIndex !== undefined) && (columnSelector1.addedColumnIndex === undefined)) {
        return ((columnSelector2.addedColumnIndex === undefined) && (columnSelector1.initialColumnIndex === columnSelector2.initialColumnIndex));
      } else {
        return false;
      }
    },
    addKnowledgeResultInDisplayedKnowledgeResults: function(knowledgeResult) {
      // console.log("[addKnowledgeResultInDisplayedKnowledgeResults] knowledgeResult.columnSelector = ", knowledgeResult.columnSelector );
      // console.log("[addKnowledgeResultInDisplayedKnowledgeResults] knowledgeResult.columnSelector = ", knowledgeResult.columnSelector );
      // console.log("[addKnowledgeResultInDisplayedKnowledgeResults] knowledgeResult.columnSelector = ", knowledgeResult.columnSelector );
      // console.log("[addKnowledgeResultInDisplayedKnowledgeResults] knowledgeResult.columnSelector = ", knowledgeResult.columnSelector );

      let displayedKnowledgeResultsAlreadyExists = false;
      const updatedDisplayedKnowledgeResults = this.displayedKnowledgeResults.map(displayedKnowledgeResult => {
        if ((displayedKnowledgeResult.lineIndex === knowledgeResult.lineIndex) && (this.areSameColumnSelectors(displayedKnowledgeResult.columnSelector, knowledgeResult.columnSelector))) {
          displayedKnowledgeResultsAlreadyExists = true;
          return knowledgeResult;
        } else {
          return displayedKnowledgeResult;
        }
      });
      if (displayedKnowledgeResultsAlreadyExists === true) {
        this.displayedKnowledgeResults = updatedDisplayedKnowledgeResults;
      } else {
        this.displayedKnowledgeResults.push(knowledgeResult);
      }
/*
      const displayedKnowledgeResultToUpdate = this.displayedKnowledgeResults.find(displayedKnowledgeResult => {
        return ((displayedKnowledgeResult.lineIndex === knowledgeResult.lineIndex) && (this.areSameColumnSelectors(displayedKnowledgeResult.columnSelector, knowledgeResult.columnSelector)));
      });
      if (displayedKnowledgeResultToUpdate !== undefined) {
        // Update this displayedKnowledgeResultToUpdate
        displayedKnowledgeResultToUpdate.isWaitingKnowledgeResult = knowledgeResult.isWaitingKnowledgeResult;
        displayedKnowledgeResultToUpdate.foundCeas = knowledgeResult.foundCeas;
      } else {
        this.displayedKnowledgeResults.push(knowledgeResult);
      }
      */
      // console.log("[addKnowledgeResultInDisplayedKnowledgeResults] this.displayedKnowledgeResults = ", JSON.stringify(this.displayedKnowledgeResults));
    },
    removeAndWaitKnowledgeResultInDisplayedKnowledgeResults: function(lineIndex, columnSelector) {
      // console.log("[removeAndWaitKnowledgeResultInDisplayedKnowledgeResults] lineIndex = ", JSON.stringify(lineIndex));
      // console.log("[removeAndWaitKnowledgeResultInDisplayedKnowledgeResults] columnSelector = ", JSON.stringify(columnSelector));
      this.addKnowledgeResultInDisplayedKnowledgeResults({
        lineIndex,
        columnSelector,
        isWaitingKnowledgeResult: true,
        foundCeas: []
      });
    },
    onSelectFavoriteKnowledgeGraphResult: function(event) {
      const knowledgeFoundCea = event.knowledgeFoundCea;
      const lineIndex = event.lineIndex;
      const columnSelector = event.columnSelector;
      const updatedDisplayedKnowledgeResults = this.displayedKnowledgeResults.map(displayedKnowledgeResult => {
        if ((displayedKnowledgeResult.lineIndex === lineIndex) && (this.areSameColumnSelectors(displayedKnowledgeResult.columnSelector, columnSelector))) {
          displayedKnowledgeResult.foundCeas = displayedKnowledgeResult.foundCeas.map(foundCea => {
            if (foundCea.isFavorite === true) {
              foundCea.isFavorite = false;
            } else if ((knowledgeFoundCea.label === foundCea.label) && (knowledgeFoundCea.uri === foundCea.uri)) {
              foundCea.isFavorite = true;
            }
            return foundCea;
          })
        }
        return displayedKnowledgeResult;
      });
      this.displayedKnowledgeResults = updatedDisplayedKnowledgeResults;
    },
    onUnselectFavoriteKnowledgeGraphResult: function(event) {
      const knowledgeFoundCea = event.knowledgeFoundCea;
      const lineIndex = event.lineIndex;
      const columnSelector = event.columnSelector;
      const updatedDisplayedKnowledgeResults = this.displayedKnowledgeResults.map(displayedKnowledgeResult => {
        if ((displayedKnowledgeResult.lineIndex === lineIndex) && (this.areSameColumnSelectors(displayedKnowledgeResult.columnSelector, columnSelector))) {
          displayedKnowledgeResult.foundCeas = displayedKnowledgeResult.foundCeas.map(foundCea => {
            if ((foundCea.isFavorite === true) && (knowledgeFoundCea.label === foundCea.label) && (knowledgeFoundCea.uri === foundCea.uri)) {
              foundCea.isFavorite = false;
            }
            return foundCea;
          })
        }
        return displayedKnowledgeResult;
      });
      this.displayedKnowledgeResults = updatedDisplayedKnowledgeResults;
    },
    onSaveAdditionalContent: function() {
      this.updateAuthJwtToken(tableApiInstance);
      tableApiInstance.saveAnnotationAdditionalContent(this.signedUser, this.selectedProjectId, this.tableId, {
        addedColumns: this.addedColumns,
        addedColumnsProperties: this.addedColumnsProperties,
        knowledgeGraphResults: this.displayedKnowledgeResults.filter((displayedKnowledgeResult) => {
          // console.log('[filter] displayedKnowledgeResult = ', displayedKnowledgeResult);
          return (displayedKnowledgeResult.isWaitingKnowledgeResult !== true)
        })
      })
        .then(saveAnnotationAdditionalContentResp => {
          console.log("[onSaveAdditionalContent] [API] [saveAnnotationAdditionalContent] [OK]");
          console.log("[onSaveAdditionalContent] saveAnnotationAdditionalContentResp = ", JSON.stringify(saveAnnotationAdditionalContentResp));
          MessageDisplayerService.showSuccessMessage(MessageDisplayerService.METHOD_NAMES.METHOD_PUT_SAVED_ADDITIONAL_CONTENT);

          this.addedColumns = saveAnnotationAdditionalContentResp.addedColumns;
          this.addedColumnsProperties = saveAnnotationAdditionalContentResp.addedColumnsProperties ? saveAnnotationAdditionalContentResp.addedColumnsProperties : [];
          this.displayedKnowledgeResults = saveAnnotationAdditionalContentResp.knowledgeGraphResults;
        })
        .catch(saveAnnotationAdditionalContentError => {
          console.log("[onSaveAdditionalContent] [API] [saveAnnotationAdditionalContent] [ERROR]", saveAnnotationAdditionalContentError);
          MessageDisplayerService.showErrorMessage(MessageDisplayerService.METHOD_NAMES.METHOD_PUT_SAVED_ADDITIONAL_CONTENT, saveAnnotationAdditionalContentError);
        });
    },
    onRemoveAdditionalContent: function() {
      this.updateAuthJwtToken(tableApiInstance);
      tableApiInstance.saveAnnotationAdditionalContent(this.signedUser, this.selectedProjectId, this.tableId, {
        addedColumns: [],
        addedColumnsProperties: [],
        knowledgeGraphResults: []
      })
        .then(saveAnnotationAdditionalContentResp => {
          console.log("[onRemoveAdditionalContent] [API] [saveAnnotationAdditionalContent] [OK]");
          console.log("[onRemoveAdditionalContent] saveAnnotationAdditionalContentResp = ", JSON.stringify(saveAnnotationAdditionalContentResp));
          MessageDisplayerService.showSuccessMessage(MessageDisplayerService.METHOD_NAMES.METHOD_PUT_SAVED_ADDITIONAL_CONTENT);

          this.addedColumns = saveAnnotationAdditionalContentResp.addedColumns;
          this.addedColumnsProperties = saveAnnotationAdditionalContentResp.addedColumnsProperties ? saveAnnotationAdditionalContentResp.addedColumnsProperties : [];
          this.displayedKnowledgeResults = saveAnnotationAdditionalContentResp.knowledgeGraphResults;
        })
        .catch(saveAnnotationAdditionalContentError => {
          console.log("[onRemoveAdditionalContent] [API] [saveAnnotationAdditionalContent] [ERROR]", saveAnnotationAdditionalContentError);
          MessageDisplayerService.showErrorMessage(MessageDisplayerService.METHOD_NAMES.METHOD_PUT_SAVED_ADDITIONAL_CONTENT, saveAnnotationAdditionalContentError);
        });
    },
    loadAdditionalContent: function() {
      this.updateAuthJwtToken(tableApiInstance);
      tableApiInstance.getSavedAnnotationAdditionalContent(this.signedUser, this.selectedProjectId, this.tableId)
        .then(getSavedAnnotationAdditionalContentResp => {
          console.log("[loadAdditionalContent] [API] [getSavedAnnotationAdditionalContent] [OK]");
          console.log("[loadAdditionalContent] getSavedAnnotationAdditionalContentResp = ", JSON.stringify(getSavedAnnotationAdditionalContentResp));
          MessageDisplayerService.showSuccessMessage(MessageDisplayerService.METHOD_NAMES.METHOD_GET_SAVED_ADDITIONAL_CONTENT);

          this.addedColumns = getSavedAnnotationAdditionalContentResp.addedColumns;
          this.addedColumnsProperties = getSavedAnnotationAdditionalContentResp.addedColumnsProperties ? getSavedAnnotationAdditionalContentResp.addedColumnsProperties : [];
          this.displayedKnowledgeResults = getSavedAnnotationAdditionalContentResp.knowledgeGraphResults;

          this.loadConfiguredAddedKnowledgeGraphProperties();
        })
        .catch(getSavedAnnotationAdditionalContentError => {
          console.log("[loadAdditionalContent] [API] [getSavedAnnotationAdditionalContent] [ERROR]", getSavedAnnotationAdditionalContentError);
          MessageDisplayerService.showErrorMessage(MessageDisplayerService.METHOD_NAMES.METHOD_GET_SAVED_ADDITIONAL_CONTENT, getSavedAnnotationAdditionalContentError);
        });
    },
    loadConfiguredAddedKnowledgeGraphProperties: function() {
      console.log(`[initializeHiddenElementsFilter] this.selectedProjectName = ${JSON.stringify(this.selectedProjectName)}`)
      const configuredActualProjectJobs = configuredProjectsJobs.find((configuredProjectJobs) => {
        return (this.selectedProjectName !== undefined) && (configuredProjectJobs.projectSelector !== undefined) && (configuredProjectJobs.projectSelector.projectName === this.selectedProjectName);
      });
      if ((configuredActualProjectJobs !== undefined) && (configuredActualProjectJobs.configuredAddedKnowledgeGraphProperties !== undefined)) {
        const configuredAddedKnowledgeGraphProperties = { ...configuredActualProjectJobs.configuredAddedKnowledgeGraphProperties };
        // Make a copy of configuredAddedKnowledgeGraphProperties.byColumnSelector in calculatedAddedKnowledgeGraphProperties.byColumnSelector
        const calculatedAddedKnowledgeGraphProperties = {
          byColumnSelector: Array.isArray(configuredAddedKnowledgeGraphProperties.byColumnSelector) ? configuredAddedKnowledgeGraphProperties.byColumnSelector.map(a => JSON.parse(JSON.stringify(a))) : []
        };
        const configuredAddedKnowledgeGraphPropertiesHeaderNameSelectors = Array.isArray(configuredAddedKnowledgeGraphProperties.byColumnHeaderName) ? configuredAddedKnowledgeGraphProperties.byColumnHeaderName : [];
        
        const tableHeader = this.PreProcessingResultHeader;
        // console.log(`[loadConfiguredAddedKnowledgeGraphProperties] tableHeader = ${JSON.stringify(tableHeader)}`);
        // console.log(`[loadConfiguredAddedKnowledgeGraphProperties] calculatedAddedKnowledgeGraphProperties = ${JSON.stringify(calculatedAddedKnowledgeGraphProperties)}`);
        // console.log(`[loadConfiguredAddedKnowledgeGraphProperties] configuredAddedKnowledgeGraphPropertiesHeaderNameSelectors = ${JSON.stringify(configuredAddedKnowledgeGraphPropertiesHeaderNameSelectors)}`);

        configuredAddedKnowledgeGraphPropertiesHeaderNameSelectors.forEach((configuredAddedKnowledgeGraphPropertiesHeaderNameSelector) => {
          const configuredAddedKnowledgeGraphPropertiesHeaderNameSelectorIndex = tableHeader.indexOf(configuredAddedKnowledgeGraphPropertiesHeaderNameSelector.linkedColumnHeaderName)
          if (configuredAddedKnowledgeGraphPropertiesHeaderNameSelectorIndex !== -1) {
            const configuredAddedKnowledgeGraphPropertiesToInclude = {
              linkedColumnIndex: configuredAddedKnowledgeGraphPropertiesHeaderNameSelectorIndex,
              propertyHeaderName: configuredAddedKnowledgeGraphPropertiesHeaderNameSelector.propertyHeaderName,
              propertyLabel: configuredAddedKnowledgeGraphPropertiesHeaderNameSelector.propertyLabel,
              propertyUri: configuredAddedKnowledgeGraphPropertiesHeaderNameSelector.propertyUri
            }

            // Only include this AddedKnowledgeGraphProperty if this column is not alredy added
            // But always for tests
            let isAlreadyExistingConfiguredAddedKnowledgeGraphPropertiesToInclude = false;
            this.addedColumnsProperties.forEach((addedColumnsProperty) => {
              if ((isAlreadyExistingConfiguredAddedKnowledgeGraphPropertiesToInclude === false)
                  && (addedColumnsProperty.linkedColumnIndex === configuredAddedKnowledgeGraphPropertiesToInclude.linkedColumnIndex)
                  && (addedColumnsProperty.propertyLabel === configuredAddedKnowledgeGraphPropertiesToInclude.propertyLabel)
                  && (addedColumnsProperty.propertyUri === configuredAddedKnowledgeGraphPropertiesToInclude.propertyUri)) {

                    isAlreadyExistingConfiguredAddedKnowledgeGraphPropertiesToInclude = true;

                  }
            });
            if (!isAlreadyExistingConfiguredAddedKnowledgeGraphPropertiesToInclude) {
              calculatedAddedKnowledgeGraphProperties.byColumnSelector.push(configuredAddedKnowledgeGraphPropertiesToInclude);
            }
          }
        })

        console.log(`[loadConfiguredAddedKnowledgeGraphProperties] calculatedAddedKnowledgeGraphProperties = ${JSON.stringify(calculatedAddedKnowledgeGraphProperties)}`);

        calculatedAddedKnowledgeGraphProperties.byColumnSelector.forEach((calculatedAddedKnowledgeGraphPropertiesColumnSelector) => {
          if (tableHeader.length > calculatedAddedKnowledgeGraphPropertiesColumnSelector.linkedColumnIndex) {
            this.onAddNewPropertyColumn({
              startColumnIndex: calculatedAddedKnowledgeGraphPropertiesColumnSelector.linkedColumnIndex,
              property: {
                pLabel: calculatedAddedKnowledgeGraphPropertiesColumnSelector.propertyLabel,
                p: calculatedAddedKnowledgeGraphPropertiesColumnSelector.propertyUri
              },
              headerName: calculatedAddedKnowledgeGraphPropertiesColumnSelector.propertyHeaderName
            })
          }
        })

      }
    }
  }

};
</script>
<style scoped>

.clickable {
  cursor: pointer
}

legend {
  font-size: 1rem;
}

</style>